export class ActivityQueue {
  constructor(){this.pending=[];this.seen=new Set();this.purchases=[];this.lastAt=-Infinity;this.replayIndex=0;this.current=null;}
  ingest(data,now=Date.now()){
    const valid=e=>e&&Number.isSafeInteger(e.id)&&['basket','checkout','purchase'].includes(e.kind)&&Array.isArray(e.products)&&e.products.length&&Date.parse(e.at)<=now+15000&&Date.parse(e.at)>=now-86400000;
    for(const e of data.events.filter(valid)){if(!this.seen.has(e.id)){this.seen.add(e.id);this.pending.push(e);}}
    this.purchases=data.purchases.filter(e=>valid(e)&&e.kind==='purchase');
  }
  next(now=Date.now()){
    if(now-this.lastAt<3000)return null;
    this.pending=this.pending.filter(e=>Date.parse(e.at)>=now-86400000);
    let event=this.pending.shift();
    if(!event&&now-this.lastAt>=10000){
      this.purchases=this.purchases.filter(e=>Date.parse(e.at)>=now-86400000);
      if(this.purchases.length)event=this.purchases[this.replayIndex++%this.purchases.length];
    }
    if(event){this.lastAt=now;this.current=event;return event;}return null;
  }
}
export function activityAge(at,now=Date.now()){
  const seconds=Math.max(0,Math.floor((now-Date.parse(at))/1000));
  if(seconds<10)return 'Just now';if(seconds<60)return seconds+' seconds ago';
  const minutes=Math.floor(seconds/60);if(minutes<60)return minutes+' minute'+(minutes===1?'':'s')+' ago';
  const hours=Math.floor(minutes/60);return hours+' hour'+(hours===1?'':'s')+' ago';
}
export function activityCopy(event){
  let who='A customer';
  if(/^[A-Z]{2}$/.test(event.country||'')){try{const country=new Intl.DisplayNames(['en-GB'],{type:'region'}).of(event.country);if(country&&country!==event.country)who=String.fromCodePoint(...[...event.country].map(c=>127397+c.charCodeAt(0)))+' '+who+' from '+(['GB','US','AE','NL'].includes(event.country)?'the ':'')+country;}catch{}}
  const names=[...new Set(event.products.map(p=>String(p.name).split(' + ')[0].replace(/\s*50ml\s*/gi,' ').trim()))];
  const product=names.length>2?names.slice(0,2).join(' and ')+' + '+(names.length-2)+' more':names.join(' and ');
  return who+(event.kind==='basket'?' added '+product+' to their basket':event.kind==='checkout'?' began checkout with '+product:' purchased '+product);
}
if(typeof window!=='undefined'&&!customElements.get('scentality-live-activity')){
 const widgets=new Set(),queue=new ActivityQueue();let cursor=0,busy=false,poll,tick,lastSuccess=0;
 const preview=window.Shopify?.theme?.role!=='main'&&new URLSearchParams(location.search).get('sc_activity_preview')==='1';
 function render(el,event){
  el.hidden=false;el.querySelector('[data-sc-event-copy]').textContent=activityCopy(event);
  const time=el.querySelector('time');time.dateTime=event.at;time.textContent=activityAge(event.at);
  const images=el.querySelector('[data-sc-event-images]');images.replaceChildren();
  for(const product of event.products.slice(0,2)){
   try{const url=new URL(product.image);if(url.protocol!=='https:'||url.hostname!=='cdn.shopify.com')continue;
    const img=document.createElement('img');img.src=url.href;img.alt=product.name;img.width=46;img.height=56;img.loading='lazy';images.append(img);}catch{}
  }
 }
 function update(){
  if(document.hidden)return;
  const event=queue.next();
  widgets.forEach(el=>{
   if(el.dataset.editor==='true')return;
   if(!lastSuccess||Date.now()-lastSuccess>60000){el.hidden=true;return;}
   if(event)render(el,event);
   else if(queue.current&&Date.now()-Date.parse(queue.current.at)<86400000){if(el.hidden)render(el,queue.current);else el.querySelector('time').textContent=activityAge(queue.current.at);}
   else el.hidden=true;
  });
 }
 async function refresh(){
  if(busy||document.hidden)return;
  const source=[...widgets].find(el=>el.dataset.editor!=='true');
  if(!source||(!preview&&Date.now()<Date.parse(source.dataset.start)))return;
  busy=true;
  try{
   const url=new URL(source.dataset.feed);url.pathname='/api/activity';url.search='';url.searchParams.set('after',cursor);if(preview)url.searchParams.set('preview','1');
   const r=await fetch(url.href,{credentials:'omit',cache:'no-store',signal:AbortSignal.timeout(5000)});if(!r.ok)throw Error();
   const data=await r.json();const time=Date.parse(data.generatedAt);
   if(data.enabled!==true||!Array.isArray(data.events)||!Array.isArray(data.purchases)||!Number.isSafeInteger(data.cursor)||!Number.isFinite(time)||Date.now()-time>60000||time-Date.now()>15000)throw Error();
   queue.ingest(data);cursor=data.cursor;lastSuccess=Date.now();update();
  }catch{if(Date.now()-lastSuccess>60000)widgets.forEach(el=>{if(el.dataset.editor!=='true')el.hidden=true;});}finally{busy=false;}
 }
 customElements.define('scentality-live-activity',class extends HTMLElement{
  connectedCallback(){widgets.add(this);if(this.dataset.editor==='true')return;if(queue.current&&Date.now()-lastSuccess<60000)render(this,queue.current);refresh();if(!poll)poll=setInterval(refresh,3000);if(!tick)tick=setInterval(update,1000);}
  disconnectedCallback(){widgets.delete(this);if(!widgets.size){clearInterval(poll);clearInterval(tick);poll=tick=null;}}
 });
 document.addEventListener('visibilitychange',()=>{if(!document.hidden)refresh();});
}
